import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { errorMessage } from "../lib/api";
import { Lock, Mail, Loader2, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin");
        } catch (err) {
            setError(errorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="grid min-h-[calc(100vh-4rem)] place-items-center px-5 py-10">
            <div className="w-full max-w-md">
                <div className="fade-up rounded-xl border border-border bg-white p-8 shadow-[0_1px_0_0_rgba(0,0,0,0.04)]">
                    <div className="mb-6 flex items-center gap-3">
                        <div className="grid h-11 w-11 place-items-center rounded-lg bg-primary text-primary-foreground">
                            <ShieldCheck size={20} strokeWidth={1.75} />
                        </div>
                        <div>
                            <h1 className="font-heading text-2xl font-semibold tracking-tight">Login Admin</h1>
                            <p className="text-sm text-muted-foreground">Kelola produk &amp; QR katalog Anda.</p>
                        </div>
                    </div>

                    <form onSubmit={onSubmit} className="space-y-4">
                        <div>
                            <label className="label-eyebrow text-muted-foreground" htmlFor="email">Email</label>
                            <div className="mt-2 flex items-center gap-2 rounded-md border border-border bg-background px-3 py-2.5 focus-within:border-primary transition-colors">
                                <Mail size={16} strokeWidth={1.6} className="text-muted-foreground" />
                                <input
                                    id="email"
                                    type="email"
                                    data-testid="admin-login-email-input"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full bg-transparent text-sm outline-none placeholder:text-muted-foreground"
                                    placeholder="Email admin"
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <label className="label-eyebrow text-muted-foreground" htmlFor="password">Password</label>
                            <div className="mt-2 flex items-center gap-2 rounded-md border border-border bg-background px-3 py-2.5 focus-within:border-primary transition-colors">
                                <Lock size={16} strokeWidth={1.6} className="text-muted-foreground" />
                                <input
                                    id="password"
                                    type="password"
                                    data-testid="admin-login-password-input"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full bg-transparent text-sm outline-none placeholder:text-muted-foreground"
                                    placeholder="••••••••"
                                    required
                                />
                            </div>
                        </div>

                        {error && (
                            <div
                                data-testid="admin-login-error"
                                className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive"
                            >
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            data-testid="admin-login-submit"
                            disabled={loading}
                            className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary px-4 py-3 text-sm font-medium text-primary-foreground transition-all duration-200 hover:opacity-90 disabled:opacity-50"
                        >
                            {loading ? <Loader2 className="animate-spin" size={16} /> : null}
                            Masuk
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
